
export default function AboutSection() {
  const stats = [
    { number: '10+', label: 'Years Experience' },
    { number: '2,500+', label: 'Successful Moves' },
    { number: '98%', label: 'Customer Satisfaction' },
    { number: '24/7', label: 'Support Available' }
  ];

  return (
    <section id="about" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          <div>
            <h2 className="text-4xl font-bold text-gray-900 mb-6">About Us</h2>
            <div className="space-y-6 text-lg text-gray-600 leading-relaxed">
              <p>
                <strong className="text-gray-900">MGM RELO LTD has been moving London for over a decade.</strong> 
                With a trusted fleet, skilled crews, and a reputation for reliability, 
                we make relocations smooth and stress-free.
              </p>
              <p>
                Beyond moving, our handyman and installation services ensure your new home or office is ready from day one. 
                Whether it's furniture assembly, curtain installation, or picture hanging, 
                we make sure every detail is taken care of.
              </p>
              <p>
                <strong className="text-gray-900">Our team works under the MGM Move · Guide · Mount standard – combining relocation, handyman services, and consultancy into one complete solution.</strong>
              </p>
            </div>

            <div className="grid grid-cols-2 sm:grid-cols-4 gap-8 mt-12">
              {stats.map((stat, index) => (
                <div key={index} className="text-center">
                  <div className="text-3xl font-bold text-blue-600 mb-2">{stat.number}</div>
                  <div className="text-gray-600 text-sm">{stat.label}</div>
                </div>
              ))}
            </div>
          </div>

          <div className="space-y-6">
            <img
              src="https://static.readdy.ai/image/87505c603ef0feae3c12190971600621/973c0ffc69619ab5ca04a7f58767f64f.jfif"
              alt="MGM RELO LTD Team"
              className="w-full h-80 object-cover object-top rounded-2xl shadow-lg"
            />
            
            <img
              src="https://static.readdy.ai/image/87505c603ef0feae3c12190971600621/501e5c19777eaa1111382e69ada41394.jfif"
              alt="Professional Moving Boxes Storage"
              className="w-full h-80 object-cover object-top rounded-2xl shadow-lg"
            />
          </div>
        </div>
      </div>
    </section>
  );
}
